import BaseModel from './BaseModel';

/** Class representing an activity. */
class ActivityReward extends BaseModel {}

export default ActivityReward;
